export default __webpack_public_path__ + "static/media/linkedinlogo.01c2af76.png";